import { Card } from '../common/Card';
import type { ContainerStatus } from '../../types/vps';

interface DockerContainersCardProps {
  containers: ContainerStatus[];
}

export function DockerContainersCard({ containers }: DockerContainersCardProps) {
  return (
    <Card title="Docker Containers">
      {containers.length === 0 ? (
        <p className="text-sm text-text-muted py-2">No container data available</p>
      ) : (
        <div className="space-y-3 py-1">
          {containers.map((container) => (
            <div key={container.name} className="flex items-center gap-3">
              <div
                className={`h-2.5 w-2.5 shrink-0 rounded-full ${
                  container.healthy ? 'bg-success' : 'bg-error'
                }`}
              />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-text-primary truncate">
                  {container.name}
                </p>
                <p className="text-xs text-text-muted">
                  {container.state}
                  {container.status_text ? ` — ${container.status_text}` : ''}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
}

export default DockerContainersCard;
